import { Product, ProductLinkedContract } from '@/types/ProductType';

export function productHasLinkedContract(product: Product): boolean {
  const c = product.contract;
  if (c == null) return false;
  if (typeof c === 'string') return c.length > 0;
  return true;
}

/** True when the linked contract is ratified (product flag and/or contract document). */
export function isProductContractRatified(product: Product): boolean {
  if (product.contractRatified === true) return true;
  const c = product.contract;
  if (c && typeof c === 'object') {
    const doc = c as ProductLinkedContract;
    if (doc.isRatified === true) return true;
    if (doc.contractStatus === 'ratified') return true;
  }
  return false;
}

/** Contract id for routing/APIs whether `contract` is an id string or populated doc. */
export function getProductContractId(product: Product): string | undefined {
  const c = product.contract;
  if (!c) return undefined;
  if (typeof c === 'string') return c;
  const id = (c as ProductLinkedContract)._id;
  if (id == null) return undefined;
  return typeof id === 'string' ? id : String(id);
}
